import {
  LotteryDrawSchema,
  LotterySchema,
  RetailUnitSchema,
} from '@lotta/shared/types-lottery-schemas';
import type { Static } from '@sinclair/typebox';
import { Type } from '@sinclair/typebox';

export type AddWinnersParams = Static<typeof AddWinnersParamsSchema>;
export const AddWinnersParamsSchema = Type.Object(
  {
    retailUnit: RetailUnitSchema.properties.id,
    lotteryId: LotterySchema.properties.id,
    lotteryDrawId: LotteryDrawSchema.properties.id,
  },
  { additionalProperties: false, $id: 'AddWinnersParamsSchema' }
);

export type AddWinnersBody = Static<typeof AddWinnersBodySchema>;
export const AddWinnersBodySchema = Type.Object(
  {
    numberOfNewWinners: Type.Number({ minimum: 1, maximum: 10 }),
  },
  { additionalProperties: false, $id: 'AddWinnersBodySchema' }
);

export type AddWinnersResponse = Static<typeof AddWinnersResponseSchema>;
export const AddWinnersResponseSchema = Type.Object(
  {},
  { additionalProperties: false, $id: 'AddWinnersResponseSchema' }
);
